var Handlebars = require("/home/rod/work/mySVN/netball/client/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n<div class=\"container\">\n<div class=\"row spacer\"></div>\n<div class=\"row spacer\"></div>\n<div class=\"row spacer\"></div>\n"
    + ((stack1 = container.invokePartial(require("/home/rod/work/mySVN/netball/client/src/templates/filterBar.handlebars"),depth0,{"name":"filterBar","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n<ul id=\"mainTabs\" class=\"nav nav-tabs\">\n  <li id=\"drawTab\" class=\"active\"><a id=\"drawTabA\" data-toggle=\"tab\" href=\"#draw\">Draw</a></li>\n  <li id=\"ladderTab\"><a id=\"ladderTabA\" data-toggle=\"tab\" href=\"#ladder\">Ladder</a></li>\n</ul>\n\n<div id=\"mainTabContent\" class=\"tab-content\">\n    <div id=\"draw\" class=\"tab-pane fade in active\"></div>\n    <div id=\"ladder\" class=\"tab-pane fade\"></div>\n</div>\n</div>\n        ";
},"usePartial":true,"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/mainForm.handlebars
 ** module id = 54
 ** module chunks = 1
 **/